"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  order: ", ";\n  flex-grow: ", ";\n  flex-shrink: ", ";\n  flex-basis: ", ";\n  align-self: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var FlexItem = _styledComponents.default.div(_templateObject(), function (_ref) {
  var order = _ref.order;
  return order;
}, function (_ref2) {
  var flexGrow = _ref2.flexGrow;
  return flexGrow;
}, function (_ref3) {
  var flexShrink = _ref3.flexShrink;
  return flexShrink;
}, function (_ref4) {
  var flexBasis = _ref4.flexBasis;
  return flexBasis;
}, function (_ref5) {
  var alignSelf = _ref5.alignSelf;
  return alignSelf;
});

FlexItem.displayName = 'FlexItem';
FlexItem.propTypes = {
  className: _propTypes.default.string,

  /** By default, flex items are laid out in the source order. However, the order property controls the order in which they appear in the flex container. */
  order: _propTypes.default.number,

  /** This defines the ability for a flex item to grow if necessary. It accepts a unit-less value that serves as a proportion. It dictates what amount of the available space inside the flex container the item should take up. */
  flexGrow: _propTypes.default.number,

  /** This defines the ability for a flex item to shrink if necessary. */
  flexShrink: _propTypes.default.number,

  /** This defines the default size of an element before the remaining space is distributed. It can be a length (e.g. 20%, 5rem, etc.) or auto. */
  flexBasis: _propTypes.default.oneOfType([_propTypes.default.oneOf(['auto']), _propTypes.default.string]),

  /** This allows the default alignment (or the one specified by align-items) to be overridden for individual flex items. */
  alignSelf: _propTypes.default.oneOf(['auto', 'stretch', 'flex-start', 'flex-end', 'center', 'baseline'])
};
FlexItem.defaultTypes = {
  className: '',
  order: 0,
  flexGrow: 0,
  flexShrink: 0,
  flexBasis: 'auto',
  alignSelf: 'auto'
};
var _default = FlexItem;
exports.default = _default;